'use client';

import Image from 'next/image';
import { useState } from 'react';
import { cn } from '@/lib/ui-kit/utils';

interface ResultThumbProps {
  src: string | null;
  /** Shown when there is no picture, or the one named was never uploaded. */
  fallback: string;
  width: number;
  height: number;
  className?: string;
}

/**
 * A result's picture. Some events and articles point at a picture that was
 * never uploaded; those, and the ones without any, show the placeholder
 * rather than a broken image or an empty hole.
 */
export function ResultThumb({ src, fallback, width, height, className }: ResultThumbProps) {
  const [failed, setFailed] = useState(false);
  const handleError = () => setFailed(true);
  return (
    <Image
      src={src && !failed ? src : fallback}
      alt=""
      width={width}
      height={height}
      onError={handleError}
      className={cn('shrink-0 rounded-[8px] object-cover', className)}
    />
  );
}
